import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";



import { landingPageService, type BlogCategory, type BlogListResponse, type BlogPostDetail } from "../services/landingPageService";

interface LandingBlogState {
  categories: BlogCategory[];
  posts: BlogListResponse["posts"];
  pagination: BlogListResponse["pagination"] | null;
  loading: boolean;
  error: string | null;
  currentPost: BlogPostDetail | null;
  postLoading: boolean;
  postError: string | null;
}



interface LandingBlogState {
  posts: BlogListResponse["posts"];
  pagination: BlogListResponse["pagination"] | null;
  loading: boolean;
  error: string | null;
}

const initialState: LandingBlogState = {
  categories: [],
  posts: [],
  pagination: null,
  loading: false,
  error: null,
  currentPost: null,
  postLoading: false,
  postError: null,
};
export const fetchLandingBlogPosts = createAsyncThunk(
  "landingBlog/fetch",
  async (params: { page?: number; limit?: number; search?: string; category?: string } | undefined, { rejectWithValue }) => {
    try {
      return await landingPageService.getBlogPosts(params?.page, params?.limit, { search: params?.search, category: params?.category });
    } catch (err: any) {
      return rejectWithValue(
        err?.response?.data?.message || "Failed to fetch blog posts"
      );
    }
  }
);

export const fetchLandingBlogCategories = createAsyncThunk(
  "landingBlog/fetchCategories",
  async (_: void, { rejectWithValue }) => {
    try {
      return await landingPageService.getBlogCategories();
    } catch {
      return rejectWithValue("Failed to fetch categories");
    }
  }
);

const landingBlogSlice = createSlice({
  name: "landingBlog",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchLandingBlogCategories.fulfilled, (state, action: PayloadAction<BlogCategory[]>) => {
        state.categories = action.payload;
      })
      .addCase(fetchLandingBlogPosts.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchLandingBlogPosts.fulfilled, (state, action: PayloadAction<BlogListResponse>) => {
        state.loading = false;
        state.posts = action.payload.posts;
        state.pagination = action.payload.pagination;
      })
      .addCase(fetchLandingBlogPosts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      }).addCase(fetchLandingBlogPostBySlug.pending, (state) => {
        state.postLoading = true;
        state.postError = null;
      })
      .addCase(fetchLandingBlogPostBySlug.fulfilled, (state, action: PayloadAction<BlogPostDetail>) => {
        state.postLoading = false;
        state.currentPost = action.payload;
      })
      .addCase(fetchLandingBlogPostBySlug.rejected, (state, action) => {
        state.postLoading = false;
        state.postError = action.payload as string;
      });
  },
});

export const fetchLandingBlogPostBySlug = createAsyncThunk(
  "landingBlog/fetchBySlug",
  async (slug: string, { rejectWithValue }) => {
    try {
      return await landingPageService.getBlogPostBySlug(slug);
    } catch (err: any) {
      return rejectWithValue(
        err?.response?.data?.message || "Failed to fetch blog post"
      );
    }
  }
);

export default landingBlogSlice.reducer;